// extracted by mini-css-extract-plugin
export var createdDate = "_iq-1";
export var divider = "_iq-2";
export var headerDivider = "_iq-3";
export var messagesCard = "_iq-0";
export var messagesContainer = "_iq-7";
export var messagesContainerWrapper = "_iq-4";
export var pointerCapturingButtonBoxes = "_iq-a";
export var showLeftPanelButton = "_iq-9";
export var showMoreButton = "_iq-c";
export var showMoreButtonContainer = "_iq-b";
export var summaryTitle = "_iq-6";
export var systemMessageCardWrapper = "_iq-d";
export var topButtons = "_iq-8";
export var withPadding = "_iq-5";